import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Enturmação',
    path: '/academico/turma/enturmacao/enturmacaoregular',
    name: 'enturmacao',
    component: () => import('@/views/academico/turma/enturmacao/Index.vue'),
    meta: {
      /*
       * SO a permissao generica de enturmacao abre esta tela.
       *
       * No legado sao duas entradas de menu para a MESMA tela: Enturmacao
       * (Enturmacao.aspx) e Enturmacao de Progressao Parcial
       * (Enturmacao.aspx?tipoenturmacao=1, item de menu 300600900). Aqui a tela e uma
       * so, com seletor de tipo, e ENTURMACAOPROGRESSAOPARCIAL_MENU_300600900 segue
       * declarada em ePermissoes.ts sem nenhum uso: quem tem apenas ela NAO entra.
       *
       * Isso e uma decisao em aberto, nao um esquecimento — aceitar a permissao da
       * progressao aqui muda quem alcanca a tela, e depende de como os grupos estao
       * configurados no banco de cada cliente.
       */
      permissions: [
        eTipoPermissao.ENTURMACAO_MENU_300600801
      ],
    },
    goesToMenu: true,
  },
]

